"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionMetrics = void 0;
var Experiments_1 = require("./Experiments");
var InteractionMetrics = /** @class */ (function () {
    function InteractionMetrics() {
        this.query = "";
        this.response = undefined;
        this.mostRecentSelectedSuggestion = undefined;
    }
    InteractionMetrics.getSuggestionTypes = function (s) {
        if (s && s.length > 0) {
            return s.map(function (item) { return (item.category === "GOOGLEMAPS") ? "GPA" : item.type; }).join(",");
        }
        return undefined;
    };
    InteractionMetrics.getSuggestionIds = function (s) {
        if (s && s.length > 0) {
            return s.map(function (item) { return (item.category === "GOOGLEMAPS") ? item.sourceName + ":" + item.sourceId :
                (item.essId ? item.essId.sourceName + ":" + item.essId.sourceId : "-:-"); }).join(",");
        }
        return undefined;
    };
    InteractionMetrics.prototype.logTypeaheadOpen = function (prefill) {
        this.interactionStart = Date.now();
        this.prefill = prefill;
    };
    InteractionMetrics.prototype.logTypeaheadRequest = function (query) {
        this.query = query || "";
        this.mostRecentSelectedSuggestion = undefined;
        this.response = undefined;
    };
    InteractionMetrics.prototype.logSuggestionShown = function (response) {
        this.response = response;
    };
    InteractionMetrics.prototype.logTypeaheadSelection = function (selection) {
        this.mostRecentSelectedSuggestion = this.response.sr[selection.index - 1];
    };
    InteractionMetrics.prototype.logTypeaheadEventMessage = function (m) {
        this.selectionTypeaheadEventMessage = m;
    };
    InteractionMetrics.prototype.getMetrics = function (metadata) {
        var userTypedQuery = this.query === this.prefill ? "" : this.query;
        var isAddrAutocomplete = this.response && this.response.sr && this.response.sr.length > 0
            && this.response.sr[0].category === "GOOGLEMAPS";
        var deviceType = metadata.getDevice && "function" === typeof metadata.getDevice ?
            metadata.getDevice(window.navigator.useragent) : undefined;
        var metric = __assign({ contentFlavor: "uitk", deviceType: deviceType, inputLength: userTypedQuery ? userTypedQuery.length : 0, interactionTime: this.interactionStart ? (Date.now() - this.interactionStart) : undefined, isAddrAutocomplete: isAddrAutocomplete, lob: metadata.lob, locale: metadata.locale, pageId: metadata.client, pointOfSale: window.location.hostname, selectionDepth: this.getSelectionDepth(), siteId: metadata.siteId + "", suggestionIds: this.response && InteractionMetrics.getSuggestionIds(this.response.sr), suggestionSelected: !!this.mostRecentSelectedSuggestion, suggestionShown: !!(this.response && this.response.sr && this.response.sr.length > 0), suggestionTypes: this.response && InteractionMetrics.getSuggestionTypes(this.response.sr), textInputElementId: metadata.inputId, timestamp: Date.now(), type: "TypeaheadInteraction", userAgent: window.navigator.userAgent, userTypedQuery: userTypedQuery, variants: [this.response && this.response.activeABTests, Experiments_1.Experiments.getClientVariants()]
                .filter(Boolean).join("|"), zeroResults: this.response && this.response.sr && this.response.sr.length === 0 }, this.selectionTypeaheadEventMessage);
        return metric;
    };
    InteractionMetrics.prototype.getSelectionDepth = function () {
        if (this.mostRecentSelectedSuggestion
            && typeof this.mostRecentSelectedSuggestion.index !== "undefined") {
            return (parseInt(this.mostRecentSelectedSuggestion.index, 10) + 1).toString();
        }
        return "undefined";
    };
    return InteractionMetrics;
}());
exports.InteractionMetrics = InteractionMetrics;
//# sourceMappingURL=InteractionMetrics.js.map